(function() {
  'use strict';
  angular.module('common')
  .filter('location', function() {
    function addComponent(c) {
      if (c) {
        return c + ' ';
      }
      return '';
    }
    return function(location) {
      if (location && location.centerId) {
        return addComponent(location.address1) +
          addComponent(location.address2) +
          addComponent(location.city) +
          addComponent(location.state);
      }
      return '';
    };
  });
})();
